import React from "react";
import { LANDING_PAGE } from "../Constants";

export default function ErrorBoundary() {
  return (
    <>
      <h1>
        <i className="paddingtop20 fa-left-padding fa-solid fa-triangle-exclamation"></i>
        <i className="fa-left-padding fa-solid fa-triangle-exclamation"></i>
        <i className="fa-left-padding fa-solid fa-triangle-exclamation"></i>
        <i className="fa-left-padding fa-solid fa-triangle-exclamation"></i>
        <i className="fa-left-padding fa-solid fa-triangle-exclamation"></i>
      </h1>
      <h1 className="paddingtop20">Sorry, something went wrong!</h1>
      <div className="paddingtop20">
        <a href={LANDING_PAGE} className="buttonRed">
          Return to landing page
        </a>
      </div>
    </>
  );
}
